import { get, isNil, isNumber } from 'lodash-es'
import { useCallback } from 'react'
import { MapKeyCodeToID } from './KeyCode'
import { useTheme } from '@mui/material'

const useKeyCode = () => {
    const theme = useTheme()
    const hightlight = isNil(theme) ? '#10AC84' : theme.palette.primary.main
    const hoverKeyPress = useCallback(
        (key: any) => {
            let buttonKey = get(
                MapKeyCodeToID,
                isNumber(key) ? `numpad${key}` : key.toString(),
            )
            document
                .getElementById(buttonKey)
                ?.setAttribute(
                    'style',
                    `background-color: ${hightlight}; color: white;`,
                )
            setTimeout(() => {
                document.getElementById(buttonKey)?.setAttribute('style', ``)
            }, 250)
        },
        [hightlight],
    )

    return {
        hoverKeyPress,
    }
}

export default useKeyCode
